import { DIALOG_TYPES } from "../../components/branch-deployer/BranchDeployer.consts";
import {
  getAllDeployments,
  createMultiServicesDeploy,
  deleteMultiServicesDeploy,
  getDeploymentStatusByReleaseName
} from "../../queries/services/multiServices";

const createBranchDeployerSlice = (set, get) => ({
  branchDeployerRows: null,
  branchDeployerError: false,
  isBranchDialogLoading: false,
  isRefreshingRowSelector: false,

  setBranchDeployerError: error =>
    set(
      { branchDeployerError: error }
    ),

  getBranchDeployerRows: async (page = 0, perPage = 50) => {
    try {
      const branchDeployerRows = await getAllDeployments({
        page,
        perPage
      });

      // add calculated data not sent by server
      const fullBranchDeployerRows = branchDeployerRows.map(bd => {
        if (bd.assistantId && bd["widget_client_tag"]) {
          return ({
            ...bd,
            "widget_client_url": `${bd["widget_client_url"]}/index.html?id=${bd.assistantId}&widgetServerUrl=${bd["widget-server-url"].replace("https", "wss")}`
          });
        }
        return bd;

      });

      set({ branchDeployerRows: fullBranchDeployerRows });
    }
    catch (e) {
      console.error(e);
    }
  },

  createBranchDeployer: async (branchDeployerData) => {
    try {
      const newBranchDeployer = await createMultiServicesDeploy(branchDeployerData);
      set(
        {
          branchDeployerRows: [newBranchDeployer, ...get().branchDeployerRows]
        });
      return false;
    }
    catch (e) {
      set(
        {
          branchDeployerError: true
        });
      console.error(e);
      return true;
    }
  },

  editBranchDeployer: async (branchDeployerData) => {
    try {
      const editedBranchDeployer = await createMultiServicesDeploy(branchDeployerData);
      const branchDeployerRows = [editedBranchDeployer, ...get().branchDeployerRows.filter(bd =>
        bd.releaseName !== branchDeployerData.releaseName
      )];
      set({ branchDeployerRows });
    }
    catch (e) {
      set(
        {
          branchDeployerError: true
        });
      console.error(e);
    }
  },

  deleteBranchDeployer: async (releaseName) => {
    try {
      const editedBranchDeployer = await deleteMultiServicesDeploy(releaseName);
      const branchDeployerRows = [editedBranchDeployer, ...get().branchDeployerRows.filter(bd =>
        bd.releaseName !== releaseName
      )];
      set({ branchDeployerRows });
    }
    catch (e) {
      set(
        {
          branchDeployerError: true
        });
      console.error(e);
    }
  },

  getBranchDeployerStatus: async (releaseName) => {
    const branchDeployerRows = get().branchDeployerRows.map(bd =>
      bd.releaseName === releaseName ? { ...bd, status: DIALOG_TYPES.refresh.id } : bd
    );
    set({ branchDeployerRows });

    try {
      const editedBranchDeployer = await getDeploymentStatusByReleaseName(releaseName);
      const branchDeployerRows = [editedBranchDeployer, ...get().branchDeployerRows.filter(bd =>
        bd.releaseName !== releaseName
      )];
      set({ branchDeployerRows });
    }
    catch (e) {
      set(
        {
          branchDeployerError: true
        });
      console.error(e);
    }
    set({ isRefreshingRowSelector: false });
  }
});

export default createBranchDeployerSlice;
